import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { requestAnimationFrame } from '@jd/jmtd-tools/es/animation';
/*
  options: {
    bgColors: 'xxx',  // 背景颜色   多个的话是数组
    pgColors: 'xxx',  // 进度条颜色 多个的话是数组
    percent: 'xx%',   // 进度条百分比 多个的话是数组
    angle: 'round',   // 定义进度条直角还是圆角  plane
    animated: false/true,  // 是否支持入场动画
    duration: 500，        // 动画执行时间
    startAnimate: false, // 是否进入当前视角开始执行入场动画
    strokeWidth: 10   // 线条/进度条粗细
    size: 20,  // 画布宽度高度
    radius: 10
  }
*/

var CircleProgress = /*#__PURE__*/function (_Component) {
  _inherits(CircleProgress, _Component);

  var _super = _createSuper(CircleProgress);

  function CircleProgress(props) {
    var _this;

    _classCallCheck(this, CircleProgress);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "calculatePath", function (percent, open) {
      var end = _this.start + percent / 100 * _this.circ; // 计算每次进度在整个圆的弧度占比

      var endPrecise = _this.precise(end);

      return _this.arc(endPrecise, open);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateStaticPath", function (percent, open, idx) {
      // 需要通过this.saveStartPrecise保存每次的终点位置，类似于日历的翻页不管循环多少次都会记住各自的值
      if (idx === 0) _this.saveStartPrecise[idx] = _this.precise(_this.start);else {
        _this.saveStartPrecise[idx] = _this.stagePrecise;
      } // 计算本次进度占整个圆的弧度占比 为上次进度+整个圆的弧长占比

      var end = _this.saveStartPrecise[idx] + percent / 100 * _this.circ;
      _this.startPrecise = _this.saveStartPrecise[idx];
      return _this.arc(_this.precise(end), open);
    });

    _defineProperty(_assertThisInitialized(_this), "calculateMovingPath", function (percent, open, idx) {
      var drawIndex = _this.state.drawIndex;

      if (idx === drawIndex) {
        var end = _this.start + percent / 100 * _this.circ; // 计算每次进度在整个圆的弧度占比

        var endPrecise = _this.precise(end);

        _this.pathArr[idx] = _this.arc(endPrecise, open);
        return _this.pathArr[idx];
      }

      return _this.pathArr[idx];
    });

    _defineProperty(_assertThisInitialized(_this), "arc", function (end, open) {
      var radius = _this.state.radius;
      _this.stagePrecise = end;
      var endAdjusted = end - 0.001;
      var longArc = end - _this.startPrecise < Math.PI ? 0 : 1; // 1

      return ['M', // 用来指定起始坐标点 x0, y0  10+5-0.45 公式：圆弧中心+半径*cos(弧度)
      radius + _this.radiusAdjusted * Math.cos(_this.startPrecise), radius + _this.radiusAdjusted * Math.sin(_this.startPrecise), 'A', // arcTo   // 用来指定画圆弧，指定rx ry半径
      _this.radiusAdjusted, _this.radiusAdjusted, 0, // rotation 旋转角度
      longArc, // large-arc-flag 在超过半圆（派/2）为大圆弧，否则为小圆弧
      1, // sweep-flag 标识是否要交换标记位 1是顺时针 0是逆时针 选择不同位置就不同
      radius + _this.radiusAdjusted * Math.cos(endAdjusted), // x1 结束坐标点
      radius + _this.radiusAdjusted * Math.sin(endAdjusted), // y1 结束坐标点
      open ? '' : 'Z' // close   // Z代表关闭路径
      ].join(' ');
    });

    _defineProperty(_assertThisInitialized(_this), "precise", function (value) {
      return Math.round(value * 1000) / 1000;
    });

    _defineProperty(_assertThisInitialized(_this), "updateRadius", function (radius) {
      _this.radius = radius;
      return _this.initGenerate().update(true);
    });

    _defineProperty(_assertThisInitialized(_this), "updateWidth", function (width) {
      _this.strokeWidth = width;
      return _this.initGenerate().update(true);
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (value, duration) {
      var oldPercentage = _this.getPercent();

      _this.initPercent = Math.min(100, Math.max(0, value));

      if (value === true) {
        _this.setPercentage(_this.getPercent());

        return _assertThisInitialized(_this);
      } // eslint-disable-next-line no-restricted-globals


      if (!value || isNaN(value)) return false; // eslint-disable-next-line no-restricted-globals

      if (isNaN(duration)) duration = 100;

      var self = _assertThisInitialized(_this);

      var newPercentage = self.getPercent();
      var isGreater = newPercentage > oldPercentage;
      self.invl += newPercentage % 1;
      var steps = Math.floor(Math.abs(newPercentage - oldPercentage) / self.invl); // 这样计算的进程越短动画越慢

      var stepDuration = duration / steps;

      (function animate(lastFrame) {
        if (isGreater) {
          oldPercentage += self.invl;
          self.oldText += self.invl;
        } else {
          oldPercentage -= self.invl;
        }

        if (isGreater && oldPercentage >= newPercentage || !isGreater && oldPercentage <= newPercentage) {
          requestAnimationFrame(function () {
            self.setPercentage(newPercentage);
            self.index++;

            if (self.props.percent[self.index]) {
              // self.index = self.state.drawIndex + 1;
              self.setState({
                drawIndex: self.state.drawIndex + 1
              });
            } else {
              // 进度结束
              self.oldText = self.total;
              self.forceUpdate();
            }
          });
          return;
        }

        self.setPercentage(oldPercentage);
        requestAnimationFrame(function () {
          self.setPercentage(oldPercentage);
        });
        var now = Date.now(),
            deltaTime = now - lastFrame;

        if (deltaTime >= stepDuration) {
          animate(now);
        } else {
          self.timer = setTimeout(function () {
            animate(Date.now());
          }, stepDuration - deltaTime);
        }
      })(Date.now());

      return _assertThisInitialized(_this);
    });

    _defineProperty(_assertThisInitialized(_this), "getValueFromPercent", function (percentage) {
      return _this.maxValue * percentage / 100;
    });

    _defineProperty(_assertThisInitialized(_this), "setPercentage", function (percentage) {
      _this.percentage = percentage;

      _this.forceUpdate();
    });

    _defineProperty(_assertThisInitialized(_this), "getPercent", function () {
      return _this.initPercent * 100 / 100;
    });

    _defineProperty(_assertThisInitialized(_this), "getText", function () {
      var _this$state = _this.state,
          textFormatter = _this$state.textFormatter,
          drawIndex = _this$state.drawIndex,
          percent = _this$state.percent,
          pgColors = _this$state.pgColors,
          text = _this$state.text,
          animate = _this$state.animate;
      if (text || text === 0) return text;

      if (textFormatter && typeof textFormatter === 'function') {
        if (_this.stage !== drawIndex && textFormatter) {
          _this.stage = drawIndex;
          _this.textArr[drawIndex] = textFormatter({
            stage: drawIndex,
            percent: percent[drawIndex],
            pgColor: pgColors[drawIndex]
          });
        }

        return _this.textArr[drawIndex];
      }

      if (!animate) return _this.total; // eslint-disable-next-line no-restricted-globals

      if (_this.oldText !== undefined && isNaN(_this.oldText)) return '';
      return String(_this.oldText).indexOf('.') > -1 ? _this.oldText.toFixed(2) : _this.oldText;
    });

    _this.state = {
      className: props.className,
      size: props.size,
      // 100
      radius: props.size / 2,
      //  50 半径
      duration: props.duration,
      //  不传为0没有动画过渡效果
      bgColors: props.bgColors,
      //  'rgba(238,130,238, 0.3)' || []
      pgColors: props.pgColors,
      //  'rgba(238,130,238)'      || []
      percent: props.percent,
      //   40  || [50, 20, 10],
      angleType: props.angleType,
      //   'round',
      strokeWidth: props.strokeWidth,
      // 10
      textStyle: props.textStyle,
      textFormatter: props.textFormatter,
      text: props.text,
      drawIndex: 0,
      animate: props.animate,
      // 是否有动画过渡
      gradient: props.gradient
    };
    _this.svg = null;
    _this.radiusAdjusted = props.size / 2 - props.strokeWidth / 2; // 调整半径：半径减去线宽的一半 用来算坐标系 45
    // 结束弧度 简写rad

    var endAngleRad = Math.PI / 180 * 270; // Math.PI为3.1415926  4.7123889

    _this.start = -(Math.PI / 180) * 90; // 弧度 = Math.PI /180 * 角度   -1.57079...

    _this.startPrecise = _this.precise(_this.start); // -1.570

    _this.circ = endAngleRad - _this.start; // 360 // 6.28318 计算整个圈的弧度

    _this.maxValue = 100; // 进度条最大值占比

    _this.initPercent = 0; // 初始percent

    _this.invl = 1;
    _this.index = 0;
    _this.percentage = null;
    _this.pathArr = Array.from(Array(props.percent.length), function () {
      return 'M 0 0 A 0 0 0 0 1 0 0';
    });
    _this.stagePrecise = 0;
    _this.saveStartPrecise = [];
    _this.total = props.percent.reduce(function (pre, num) {
      return pre + num;
    });
    _this.oldText = 0;
    _this.textArr = [];
    return _this;
  }

  _createClass(CircleProgress, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$state2 = this.state,
          percent = _this$state2.percent,
          duration = _this$state2.duration,
          animate = _this$state2.animate,
          drawIndex = _this$state2.drawIndex;
      this.svgWrap = document.getElementsByClassName('jmtd-circle-wrap')[0];
      animate && percent[drawIndex] && this.update(percent[drawIndex] || 0, duration);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var percent = nextState.percent,
          duration = nextState.duration,
          animate = nextState.animate,
          drawIndex = nextState.drawIndex;
      var preDrawIndex = this.state.drawIndex;

      if (drawIndex !== preDrawIndex && percent[drawIndex]) {
        // console.log('shouldComponentUpdate', this.state.startAnimate);
        this.start = this.stagePrecise; // 将this.start更改为上一次的进度

        this.startPrecise = this.stagePrecise;
        this.initPercent = 0; // 将initPercent重置为0开始第二段动画

        animate && percent[drawIndex] && this.update(percent[drawIndex] || 0, duration);
      }

      return true;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.timer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state3 = this.state,
          className = _this$state3.className,
          size = _this$state3.size,
          percent = _this$state3.percent,
          bgColors = _this$state3.bgColors,
          pgColors = _this$state3.pgColors,
          strokeWidth = _this$state3.strokeWidth,
          angleType = _this$state3.angleType,
          animate = _this$state3.animate,
          textStyle = _this$state3.textStyle,
          gradient = _this$state3.gradient;

      var style = _objectSpread({
        position: 'absolute',
        top: 0,
        left: 0,
        textAlign: 'center',
        width: '100%',
        fontFamily: 'JDZhengHei-jmt',
        fontSize: "".concat(size * 0.2, "px"),
        height: "".concat(size, "px"),
        lineHeight: "".concat(size, "px")
      }, textStyle);

      var needGradient = percent.length === 1 && gradient;
      return /*#__PURE__*/React.createElement("div", {
        id: this.props.id,
        className: "jmtd-circle-wrap ".concat(className)
      }, /*#__PURE__*/React.createElement("svg", {
        width: size,
        height: size
      }, /*#__PURE__*/React.createElement("path", {
        className: "jmtd-bg-path",
        fill: "transparent",
        stroke: bgColors[0],
        strokeWidth: strokeWidth,
        strokeLinecap: angleType,
        d: this.calculatePath(100, true)
      }),
      /* 每次进度变更都动态生成各自的path，防止不同demo之间的影响 */
      percent.map(function (value, idx) {
        return /*#__PURE__*/React.createElement("g", {
          key: idx
        }, needGradient && /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
          id: "gradient-".concat(pgColors[idx])
        }, /*#__PURE__*/React.createElement("stop", {
          offset: "5%",
          stopColor: pgColors[idx]
        }), /*#__PURE__*/React.createElement("stop", {
          offset: "90%",
          stopColor: pgColors[idx + 1]
        }))), /*#__PURE__*/React.createElement("path", {
          // strokeDasharray={1000}
          // strokeDashoffset={1000}
          // animation='dash 5s linear forwards'
          key: idx,
          className: "jmtd-pg-path-stage-".concat(idx),
          fill: "transparent",
          stroke: needGradient ? "url('#gradient-".concat(pgColors[idx], "')") : pgColors[idx],
          strokeWidth: strokeWidth,
          strokeLinecap: percent.length === 1 ? angleType : 'butt',
          d: animate ? _this2.calculateMovingPath(_this2.percentage, true, idx) : _this2.calculateStaticPath(value, true, idx)
        }));
      })), /*#__PURE__*/React.createElement("div", {
        className: "jmtd-circle-text",
        style: style
      }, this.getText()));
    }
  }]);

  return CircleProgress;
}(Component);

export default CircleProgress;
CircleProgress.propTypes = {
  id: PropTypes.string,
  duration: PropTypes.number,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
  percent: PropTypes.array,
  bgColors: PropTypes.array,
  pgColors: PropTypes.array,
  className: PropTypes.string,
  angleType: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.node]),
  textStyle: PropTypes.object,
  textFormatter: PropTypes.func,
  animate: PropTypes.bool,
  // 使用动画
  gradient: PropTypes.bool // 是否使用渐变，只有单段进度条才会生效

};
CircleProgress.defaultProps = {
  id: null,
  className: '',
  size: 100,
  duration: 100,
  percent: [0],
  strokeWidth: 10,
  bgColors: ['rgba(238,130,238,0.3)', 'rgba(0,255,0,0.3)'],
  pgColors: ['rgba(238,130,238)', 'rgba(0,255,0)'],
  angleType: 'round',
  textStyle: {},
  text: null,
  textFormatter: null,
  animate: false,
  gradient: false
};